module.exports = new __parcel__URL__("customer-contracts.c7c17a00.html").toString();